<script>

    import { fade } from 'svelte/transition';
    let { uploadTask, name } = $props();

    let progress = $state(0);
    
    let status = $state('running');
    

    let me = $state(null);

    uploadTask.on('state_changed', (sn) => {
        progress = sn.bytesTransferred / sn.totalBytes;
        status = sn.state;
    });

    uploadTask.then(() => {
        status = 'success';
        me.parentNode.removeChild(me);
    });

    uploadTask.catch((err) => {
        status = 'error';
        console.error(err);
        me.parentNode.removeChild(me);
    });

    function handlePause(e) {
        uploadTask.pause();
    }

    function handleCancel(e) {
        uploadTask.cancel();
        me.parentNode.removeChild(me);
    }

    function handleResume(e) {
        uploadTask.resume();
    }

    export {
    	uploadTask,
    	name,
    };
</script>

<div
    bind:this={me}
    class="file-upload-chip"
    out:fade={{ delay: 500, duration: 1000 }}
>
    <div class="progress {status}" style="width:{Math.ceil(progress * 100)}%"></div>
    <span class="progress-label">{Math.round(progress * 100)}%</span>
    <span class="filename">{name}</span>
    <div class="spacer"></div>
    {#if status === 'running' && status !== 'success'}
        <!-- svelte-ignore a11y_click_events_have_key_events -->
        <i onclick={handlePause} class="material-icons interactive"
            >pause_circle</i
        >
    {/if}
    {#if status === 'paused' && status !== 'success'}
        <!-- svelte-ignore a11y_click_events_have_key_events -->
        <i onclick={handleResume} class="material-icons interactive"
            >play_circle</i
        >
    {/if}
    {#if status === 'success'}
        <!-- svelte-ignore a11y_click_events_have_key_events -->
        <i onclick={handleCancel} class="material-icons interactive"
            >check_circle</i
        >
    {:else}
        <!-- svelte-ignore a11y_click_events_have_key_events -->
        <i onclick={handleCancel} class="material-icons interactive">cancel</i>
    {/if}
</div>

<style>
    .file-upload-chip {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: #555;
        padding: 0.25rem 0.25rem 0.25rem 1rem;
        border-radius: 0.25rem;
        margin: 0.25rem;
        font-size: 0.8rem;
        color: #111;
        box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.25);
    }

    .file-upload-chip i {
        padding: 0.5rem;
        border-radius: 10rem;
        font-size: 1.3rem;
    }

    .file-upload-chip i:hover {
        background-color: rgba(255, 255, 255, 0.2);
        color: #000;
    }

    .progress-label {
        display: flex;
        flex-shrink: 0;
        justify-content: flex-start;
        font-size: 0.8rem;
        font-weight: 600;
        width: 3rem;
    }

    .progress {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        border-radius: 0.25rem;
    }

    .running {
        background-color: rgb(74, 255, 83);
    }

    .paused {
        background-color: rgb(255, 192, 74);
    }

    .success {
        background-color: rgb(74, 255, 83);
    }

    .canceled {
        background-color: crimson;
    }

    .error {
        background-color: crimson;
    }

    .filename {
        display: block;
        width: 8rem;
        font-size: 0.8rem;
        overflow: hidden;
    }
</style>
